import useGet from "../useGet";

export type CompanySummary = {
  id: number;
  name: string;
  searchResult?: boolean;
  childSearchResults?: boolean;
};

const useCompanies = (dependencies: any[]) => {
  const { value, loading } = useGet(
    "/api/Companies?ts=" + new Date().getTime(),
    "Unable to read companies",
    [],
    dependencies
  );

  return {
    companies: value as CompanySummary[],
    companiesLoading: loading as boolean
  };
};

export default useCompanies;
